import { useMutation } from '@tanstack/react-query';

import type {
  CertificateFormData,
  CertificateFormResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCertificateFormMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: CertificateFormData }) =>
      HttpClient.request<CertificateFormResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });

export const useUseCertificateMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: { code?: string; client_id: number; service_ids: number[] };
    }) =>
      HttpClient.request({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });

export const useSendReceiptToEmailMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<{ status: string }>({
        method: 'POST',
        url,
      }),
  });
